import React from 'react';
import { InputField } from '../InputField';
import { SelectField } from '../SelectField';
import { SignupFormData, FormErrors } from '../../types';

interface RoleCompanySizeStepProps {
  formData: SignupFormData;
  errors: FormErrors;
  updateField: (field: keyof SignupFormData, value: string | boolean) => void;
  onNext: () => void;
  onPrevious: () => void;
  onStepComplete?: (stepName: string) => void;
}

const companySizeOptions = [
  { value: '1-5', label: '1-5 employees' },
  { value: '6-10', label: '6-10 employees' },
  { value: '11-20', label: '11-20 employees' },
  { value: '21-50', label: '21-50 employees' },
  { value: '50+', label: '50+ employees' },
];

export const RoleCompanySizeStep: React.FC<RoleCompanySizeStepProps> = ({
  formData,
  errors,
  updateField,
  onNext,
  onPrevious,
  onStepComplete,
}) => {
  const isStepValid = () => {
    return (
      formData.jobTitle &&
      formData.companySize &&
      !errors.jobTitle &&
      !errors.companySize
    );
  };

  const handleNext = () => {
    if (isStepValid()) {
      // Track step completion in HubSpot
      if (onStepComplete) {
        onStepComplete('role_company_size');
      }
      onNext();
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-gray-900 mb-3">
          What's your role and how big's your company?
        </h1>
        <p className="text-gray-600">
          Help us tailor your experience from the get go.
        </p>
      </div>

      <div className="space-y-4">
        <InputField
          id="jobTitle"
          name="jobTitle"
          label="Job title"
          value={formData.jobTitle}
          onChange={(value) => updateField('jobTitle', value)}
          error={errors.jobTitle}
          required
          placeholder="e.g. Mortgage Adviser"
        />

        <SelectField
          id="companySize"
          name="companySize"
          label="Team size"
          value={formData.companySize}
          onChange={(value) => updateField('companySize', value)}
          options={companySizeOptions}
          error={errors.companySize}
          required
          placeholder="Select team size"
        />
      </div>

      <div className="flex justify-between pt-4">
        <button
          type="button"
          onClick={onPrevious}
          className="px-6 py-3 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
        >
          Previous
        </button>
        
        <button
          type="button"
          onClick={handleNext}
          disabled={!isStepValid()}
          className="px-6 py-3 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          Continue
        </button>
      </div>
    </div>
  );
};
